import "core-js/modules/es.number.constructor.js";
export default {
  name: "payOptions",
  props: {
    payArray: [],
    value: [Array, String, Number],
    type: Number
  },
  watch: {
    value: {
      handler: function handler(newVal) {
        this.label = newVal;
      }
    }
  },
  data: function data() {
    return {
      label: this.value
    };
  },
  methods: {
    someSelect: function someSelect() {
      this.$emit("input", this.label);
    }
  }
};